/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PetTypeV2FormConfigModel
 */
export interface PetTypeV2FormConfigModel {
    /**
     * 
     * @type {number}
     * @memberof PetTypeV2FormConfigModel
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof PetTypeV2FormConfigModel
     */
    submitter?: string;
    /**
     * 
     * @type {string}
     * @memberof PetTypeV2FormConfigModel
     */
    name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PetTypeV2FormConfigModel
     */
    markForDelete?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PetTypeV2FormConfigModel
     */
    pharmacyEligible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PetTypeV2FormConfigModel
     */
    vetDietEligible?: boolean;
}

/**
 * Check if a given object implements the PetTypeV2FormConfigModel interface.
 */
export function instanceOfPetTypeV2FormConfigModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PetTypeV2FormConfigModelFromJSON(json: any): PetTypeV2FormConfigModel {
    return PetTypeV2FormConfigModelFromJSONTyped(json, false);
}

export function PetTypeV2FormConfigModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): PetTypeV2FormConfigModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'submitter': !exists(json, 'submitter') ? undefined : json['submitter'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'markForDelete': !exists(json, 'markForDelete') ? undefined : json['markForDelete'],
        'pharmacyEligible': !exists(json, 'pharmacyEligible') ? undefined : json['pharmacyEligible'],
        'vetDietEligible': !exists(json, 'vetDietEligible') ? undefined : json['vetDietEligible'],
    };
}

export function PetTypeV2FormConfigModelToJSON(value?: PetTypeV2FormConfigModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'submitter': value.submitter,
        'name': value.name,
        'markForDelete': value.markForDelete,
        'pharmacyEligible': value.pharmacyEligible,
        'vetDietEligible': value.vetDietEligible,
    };
}

